import { Page } from '../../../components/pdf-export/Page/Page.js';
import { Document as PDFDocument } from '../../../summary/Document.js';
import { Tkv2MarketConditionsExportDeps } from '../../marketConditions/types.ts';
import { AdjustmentBreakdownDepreciatedCostAdjustments } from '../AdjustmentBreakdownV2/AdjustmentBreakdownDepreciatedCostAdjustments.tsx';
import { AdjustmentBreakdownMarketConditions } from '../AdjustmentBreakdownV2/AdjustmentBreakdownMarketConditions.tsx';
import { AdjustmentBreakdownSiteValue } from '../AdjustmentBreakdownV2/AdjustmentBreakdownSiteValue.tsx';
import { Tkv2PairedCostSummaryInterfaceV2 } from '../types.js';

export const SummaryExportV2 = (
  props: Tkv2PairedCostSummaryInterfaceV2 & {
    marketConditionsExportDeps: Tkv2MarketConditionsExportDeps;
    marketTrendsPngSource?: string;
    siteSizeVsSiteValuePngSource?: string;
    siteSizeVsCostPngSource?: string;
    siteToValueRatioPngSource?: string;
  },
) => {
  return (
    <PDFDocument>
      <Page title="Adjustment Breakdown">
        <AdjustmentBreakdownMarketConditions {...props} />
        <AdjustmentBreakdownSiteValue {...props} />
        <AdjustmentBreakdownDepreciatedCostAdjustments {...props} />
      </Page>
    </PDFDocument>
  );
};
